import React from 'react';
import { useTranslation } from 'react-i18next';

import { Autocomplete, TextField } from '@mui/material';

import { isArrayWithItems } from '../../../../../utils/common';

import { useUsersTableContext } from '../../store/usersTableProvider';

const getUsersTableFirstNameOptions = users => {
    if (!isArrayWithItems(users)) {
        return [];
    }

    return users
        .map(user => {
            return {
                title: user.firstName,
                value: user.firstName,
            };
        })
        .sort((a, b) => a?.value?.localeCompare(b?.value));
};

const UsersTableFirstNameFilter = ({ users, value }) => {
    const { t } = useTranslation();
    const { setUsersTableFilter } = useUsersTableContext();

    const options = getUsersTableFirstNameOptions(users);

    const inputValue = value ? options.find(option => option.value === value) : null;

    return (
        <Autocomplete
            value={inputValue}
            fullWidth
            isOptionEqualToValue={(option, value) => option.value === value?.value}
            options={options}
            getOptionLabel={option => option.title}
            renderInput={params => <TextField {...params} label={t('adminPage.usersTable.firstName')} />}
            onChange={(_, data) => {
                setUsersTableFilter({ key: 'firstNameFilter', value: data?.value });
            }}
        />
    );
};

export default UsersTableFirstNameFilter;
